// extracted by mini-css-extract-plugin
module.exports = {"main":"Headline_main__j9Hl4","firstWords":"Headline_firstWords__jM9aX"};